import { useTranslation } from 'react-i18next';

import DialogImage from '@/components/atoms/Images/DialogImage';
import EmptyPage from '@/components/templates/EmptyPage/EmptyPage';
import { Button } from '@/components/ui/button';
import useSegments from '@/segment/useSegments';
import { PageName } from '@/shared/types/segment';

interface DialogsEmptyStateProps {
  canWrite: boolean;
  isListLoaded: boolean;
  onCreate: () => void;
}

// The route redirects whenever the agent has a dialog, so only this state is a page the user sees.
const DialogsEmptyState = ({ canWrite, isListLoaded, onCreate }: DialogsEmptyStateProps) => {
  const { t } = useTranslation();

  useSegments(isListLoaded ? PageName.DIALOGS : null);

  return (
    <EmptyPage>
      <DialogImage />
      <h2>{t('dialog.empty_title')}</h2>
      <Button variant="ghost" disabled={!canWrite} onClick={onCreate}>
        {t('dialog.empty_create_plus')}
      </Button>
    </EmptyPage>
  );
};

export default DialogsEmptyState;
